var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19922 9.40313H7.79922C7.58706 9.40313 7.38354 9.31886 7.23351 9.16883C7.08349 9.0188 6.99922 8.81529 6.99922 8.60313V6.60313C6.99922 6.49705 6.95709 6.39528 6.88205 6.3203C6.80706 6.24526 6.7053 6.20312 6.59922 6.20312H6.19922",
    stroke: "#6AA8EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80156 4.60313C6.69111 4.60313 6.60156 4.51358 6.60156 4.40313C6.60156 4.29267 6.69111 4.20312 6.80156 4.20312",
    fill: "#6AA8EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80156 4.60313C6.69111 4.60313 6.60156 4.51358 6.60156 4.40313C6.60156 4.29267 6.69111 4.20312 6.80156 4.20312",
    stroke: "#6AA8EE",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80078 4.60313C6.91123 4.60313 7.00078 4.51358 7.00078 4.40313C7.00078 4.29267 6.91123 4.20312 6.80078 4.20312",
    stroke: "#6AA8EE",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z",
    stroke: "#6AA8EE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.65a9c1fcd54a2542da250fbd34b7cbee.svg";
export { ForwardRef as ReactComponent };